
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-of-service",
      function () {
        return require("private-next-pages/terms-of-service.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms-of-service"])
      });
    }
  